export default [
  {
    name: "APP_LOGIN_SUCCESS",
    callback: function () {},
  },
  {
    name: "APP_LOGOUT",
    callback: function () {
      this.$store.dispatch("logout");
      this.flashMessage.success({
        title: "Acceso",
        message: "Ha cerrado sesion correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
      this.$router.replace({ path: "/loginNew" }).catch(() => {this.$router.replace({ path: "/loginNew" });});
    },
  },
  {
    name: "APP_ON_CLOSE",
    callback: function () {
      this.$store.dispatch("logout");
      this.$router.replace({ path: "/loginNew" }).catch(() => {this.$router.replace({ path: "/loginNew" });});
    },
  },
  // {
  //   name: "APP_RESET_PASSWORD",
  //   callback: function() {
  //     this.$store.dispatch("logout");
  //     this.flashMessage.success({
  //       title: "Contraseña",
  //       message: "Ha solicitado reseteo de contraseña, verifique su correo",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //     this.$router.replace({ name: "ResetPassword" });
  //   }
  // },
  // {
  //   name: "APP_RESET_PASSWORD_GRID",
  //   callback: function() {
  //     this.flashMessage.info({
  //       title: "Contraseña",
  //       message: "Se ha enviado un correo electrónico a la casilla del usuario",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //   }
  // },
  // {
  //   name: "APP_RESET_PASSWORD_ERROR",
  //   callback: function() {
  //     this.flashMessage.warning({
  //       title: "Reseteo Contraseña",
  //       message: "Ha ocurrido un error al intentar enviar un correo electrónico para resetar la clave.",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //   }
  // },
  // {
  //   name: "APP_RESET_PASSWORD_BAD",
  //   callback: function() {
  //     this.flashMessage.warning({
  //       title: "Reseteo Contraseña",
  //       message: "Debe ingresar su correo antes de solicitar reseteo de clave",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //   }
  // },
  // {
  //   name: "APP_RESET_PASSWORD_DIFFERENT",
  //   callback: function() {
  //     this.flashMessage.error({
  //       title: "Reseteo Contraseña",
  //       message: "Las claves no coinciden",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //   }
  // },
  // {
  //   name: "APP_RESET_PASSWORD_OK",
  //   callback: function() {
  //     this.flashMessage.info({
  //       title: "Reseteo Contraseña",
  //       message: "Ha solicitado reseteo de clave, verifique su correo",
  //       time: 5000,
  //       blockClass: "custom-block-class"
  //     });
  //   }
  // },
  {
    name: "APP_SAVE",
    callback: function () {
      this.flashMessage.success({
        title: "Guardado",
        message: "Ha guardado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
      // this.$router.replace({ name: "ProcesoImpresion" });
    },
  },
  {
    name: "APP_PROCESS_ERROR",
    callback: function () {
      this.flashMessage.warning({
        title: "Guardado",
        message: "Ha ocurrido un error durante el proceso",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_SEND",
    callback: function () {
      this.flashMessage.success({
        title: "Enviado",
        message: "Se ha notificado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_CREATE",
    callback: function () {
      this.flashMessage.success({
        title: "Creado",
        message: "Se ha generado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "FILE_SEND_PROCESS",
    callback: function () {
      this.flashMessage.success({
        title: "Proceso exitoso",
        message:
          "Se procesó correctamente al archivo, ahora puede registrar el envío",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_EDIT",
    callback: function () {
      this.flashMessage.success({
        title: "Cambio",
        message: "Se ha generado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_ADMIN_FIELD",
    callback: function () {
      this.flashMessage.warning({
        title: "Mensaje",
        message:
          "Favor seleccionar proceso, indicar asunto y adjuntar documento antes de guardar",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_UPDATE",
    callback: function () {
      this.flashMessage.success({
        title: "Actualizacion",
        message: "Ha actualizado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_DELETE",
    callback: function () {
      this.flashMessage.success({
        title: "Eliminación",
        message: "Se ha eliminado correctamente",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_IMP_MEC_DIS_VISITAS_ERROR",
    callback: function () {
      this.flashMessage.warning({
        title: "Guardado",
        message: "Debe verificar los datos de ingreso",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "ERROR_EXCEPTION",
    callback: function (e) {
      this.flashMessage.warning({
        title: "",
        message: e,
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },

  {
    name: "ERROR_EXCEPTION2",
    callback: function () {
      this.flashMessage.warning({
        title: "",
        message: "No existen datos para mostrar",
        time: 6000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "ERROR_RUT",
    callback: function () {
      this.flashMessage.warning({
        title: "",
        message: "El Rut es Inválido",
        time: 6000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "DELETE_CENTRO",
    callback: function () {
      this.flashMessage.warning({
        title: "",
        message: "Se ha eliminado correctamente",
        time: 6000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "ERROR_TIPO_CAPACITACION",
    callback: function () {
      this.flashMessage.warning({
        title: "",
        message:
          "Debe seleccionar el tipo de capacitación, para consultar por el rut del relator",
        time: 6000,
        blockClass: "custom-block-class",
      });
    },
  },

  {
    name: "DATOS_INCOMPLETOS",
    callback: function () {
      this.flashMessage.warning({
        title: "",
        message: "Debe completar todos los datos requeridos",
        time: 6000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "ERROR_EXCEPTION_BACK",
    callback: function () {
      this.flashMessage.warning({
        title: "Error",
        message: "Acción no disponible",
        time: 5000,
        blockClass: "custom-block-class",
      });
    },
  },
  {
    name: "APP_UNAUTHORIZED",
    callback: function () {
      this.$store.dispatch("logout");
      this.flashMessage.warning({
        title: "Acceso",
        message: "No autorizado",
        time: 5000,
        blockClass: "custom-block-class",
      });
      window.getApp.$on("APP_UNAUTHORIZED", () => {
        try {
          this.$router.replace({ path: "/loginNew" });
        } catch (error) {
          // Manejar la excepción de navegación duplicada
          // console.warn("Error de navegación duplicada:", error.message);
        }
      });
    },
  },
  {
    name: "APP_PAGE_LOADED",
    callback: function () {},
  },
  {
    name: "APP_AUTH_FAILED",
    callback: function () {
      this.$router.push("/loginNew");
      this.$message.error("Token has expired");
    },
  },
  {
    name: "APP_BAD_REQUEST",
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    },
  },
  {
    name: "APP_ACCESS_DENIED",
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push("/forbidden");
    },
  },
  {
    name: "APP_RESOURCE_DELETED",
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    },
  },
  {
    name: "APP_RESOURCE_UPDATED",
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    },
  },
];
